{"pleaseChooseYour":"PLEASE CHOOSE YOUR","deliveryLocation":"DELIVERY LOCATION","viewAllAvailableLocations":"VIEW ALL AVAILABLE LOCATIONS","go":"GO"}